Auth = require 'db/auth'
ApiError = require 'network/api-error'
errorSignal = require 'lib/error-signal'

errorSignal.subscribe ({ error }) ->
  if error instanceof ApiError.Unauthenticated
    Auth.logoutPost()
  return

# Check to see if the idMember changes; if it does, then it means that they've
# logged out in another window, or logged in as someone else, or cleared their
# cookies or something, and any requests we make now might be unauthorized.
idMember = Auth.updateToken()
checkCookieInterval = setInterval ->
  newIdMember = Auth.updateToken()
  if newIdMember != idMember
    window.location.reload()
  idMember = newIdMember
, 3000

# After the POST /logout returned (erasing your cookie, with a 303), it started
# a race between the redirect loading (/logged-out) and the cookie change
# checker noticing that your cookie disappeared and doing a refresh. If it
# looks like we're trying to change pages, just stop checking for a cookie
# change.
window.addEventListener 'beforeunload', ->
  clearInterval checkCookieInterval
  return



// WEBPACK FOOTER //
// ./app/scripts/entry/token-watcher.coffee